import { DataTableLoadingSkeleton } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <DataTableLoadingSkeleton
      columnsCount={6}
      rowsCount={5}
      containerClassName="[&_>_div]:flex [&_>_div]:h-full [&_>_div]:flex-col [&_>_div]:justify-between"
      withStickyHeader
    />
  )
}
